import { render, staticRenderFns } from "./AllDepartments.vue?vue&type=template&id=10baa234&"
import script from "./AllDepartments.vue?vue&type=script&lang=ts&"
export * from "./AllDepartments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports